<!-- 预赛 -->
<template>
  <div class="reality-rank-buy">
    <txt-wait-res v-if="isBefore(finalRes)" :time="finalRes" />
    <div v-else-if="rank && rank.total > 0" class="k-table k-table--rank skin-reality">
      <table cellspacing="0">
        <tr>
          <th class="fst">排名</th>
          <th class="ta_left">账号信息</th>
          <th class="lst">得分</th>
        </tr>
        <tr tag="tr" v-for="item in rank.list" :key="item.uid">
          <td class="rankNo"><k-num-rank :value="item.finalRank" /></td>
          <td class="ta_left"><k-user :nick="item.mobile" :logo="item.logoSrc" /></td>
          <td class="score">{{item.finalScore}}</td>
        </tr>
      </table>
    </div>
    <txt-no-data v-else-if="rank" />
    <txt-loading v-else />
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  export default {
    name: 'final-rank-score',
    props: ['cupId'],
    computed: {
      ...mapGetters(['isBefore', 'finalRes']),
      ...mapGetters('match', {rank: 'finalRankScore'})
    },
    watch: {
      cupId(cupId) {
        if(cupId> 0) {
          this.fetch()
        }
      }
    },
    methods: {
      ...mapActions('match', ['loadFinalRank']),
      async fetch() {
        const {cupId} = this
        if(cupId> 0) {
          await this.loadFinalRank({
            cupId,
            page: 1,
            pageNum: 500
          })
        }
      }
    },
    async created() {
      await this.fetch()
    }
  };

</script>
